import { Attach } from '@/components';
import { useAppClippo } from '@/core';
import { useClippoBlobs } from '@/utils';
import { Col, Divider, Row } from 'antd';
import { ExternalDocumentListPanel } from '../ExternalDocuments.List';
import { useCommunityContext } from '../Communities.Common';

interface Props {
  communityId: string;
  className?: string;
}

export const HomeCommunityAttachments = (props: Props) => {
  const { communityId, className } = props;

  const { active } = useCommunityContext();

  const canModifyCommunity = active;

  const communityClippoProps = useAppClippo({
    defer: false,
    ownerId: communityId,
    ownerType: 'Community',
  });
  const communityClippoBlobs = useClippoBlobs(communityClippoProps);

  return (
    <>
      <Row>
        <Col>
          <Attach
            className={className}
            {...communityClippoProps}
            readonly={!canModifyCommunity}
            showActions
            blobs={communityClippoBlobs.blobs}
            multiple
          />
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col>
          <ExternalDocumentListPanel referenceId={communityId} />
        </Col>
      </Row>
    </>
  );
};
